import {Stack, styled} from '@mui/material';

const StyledHeader = styled(Stack)`
	flex: 1;
	flex-direction: row;
	align-items: start;
	gap: 12px;
`;

export {StyledHeader};
